(function () {
  'use strict';

  // Mobile menu toggle
  var toggle = document.querySelector('.header__toggle');
  var nav = document.querySelector('.header__nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.style.display = expanded ? '' : 'block';
    });
  }

  // Collection sorting
  var sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', sortSelect.value);
      window.location.search = params.toString();
    });
  }

  // Update cart count badge on add-to-cart (best-effort)
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.getAttribute('action') !== (window.Shopify && window.Shopify.routes ? window.Shopify.routes.cart_add_url : '/cart/add')) return;
    var badge = document.querySelector('.header__cart-count');
    if (badge) {
      var current = parseInt(badge.textContent, 10) || 0;
      badge.textContent = current + 1;
    }
  });
})();
